import { render, staticRenderFns } from "./AdminSms.vue?vue&type=template&id=dbeab950&scoped=true"
import script from "./AdminSms.vue?vue&type=script&lang=js"
export * from "./AdminSms.vue?vue&type=script&lang=js"
import style0 from "./AdminSms.vue?vue&type=style&index=0&id=dbeab950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeab950",
  null
  
)

export default component.exports